module.exports = __webpack_public_path__ + "media/images/roomimage-f079f3b6f9cabe50576eb50430316a14.png";